import moment from 'moment';
import { teamActionTypes } from './Team.actionTypes';

const loadTeam = localStorage.getItem('teamData');
const loadAllTeam = localStorage.getItem('Team');
const members = localStorage.getItem('members');
const topUserProjects = localStorage.getItem('topProjects');

const initialState = {
  loading: false,
  loadingProject: true,
  teamLoading: false,
  selectedTeamID: null,
  activeUserID: null,
  selectedDate: moment().format('DD:M:YYYY'),
  week: moment().isoWeek().toString(),
  timelogDayRange: 0,
  start: '',
  end: '',
  activeTeam: {},
  teamMembers: [],
  teams: loadAllTeam?.length === 0 ? [] : JSON.parse(loadAllTeam),
  teamLogs: [],
  days: [],
  projects: [],
  selectedProject: {},
  tasks: [],
  all: true,
  teamData: {},
  weekData: {},
  topData: {},
  membersData: {},
  threshold: '',
  attendanceData: [],
  active: loadTeam?.length === 0 ? [] : JSON.parse(loadTeam),
  teamTimeData: {},
  topProjects: [],
  selectedProject: '',
  selectTeams: [],
  sevenDayData: {},
  thirtyDayData: {},
  untrackedUsers: {},
  days: 0,
  companiesWithSubscription: [],
  subscriptionLoading: false,
};

export default function teamReducer(state = initialState, action) {
  switch (action.type) {
    case teamActionTypes.SET_STATE:
      return { ...state, ...action.payload };
    // NEW: Handle subscription teamActionTypes
    case teamActionTypes.SET_COMPANIES_WITH_SUBSCRIPTION:
      return {
        ...state,
        companiesWithSubscription: action.payload,
        subscriptionLoading: false,
      };
    case teamActionTypes.GET_COMPANIES_WITH_SUBSCRIPTION:
      return {
        ...state,
        subscriptionLoading: true,
      };
    case teamActionTypes.PATCH_TEAM_TIMEZONE: {
      const { teamId, timeZone } = action.payload;
      const updatedData = (state.teams?.data ?? []).map((t) =>
        t.activeTeamid === teamId ? { ...t, timeZone } : t
      );
      const updatedTeams = { ...state.teams, data: updatedData };
      localStorage.setItem('Team', JSON.stringify(updatedTeams));
      return { ...state, teams: updatedTeams };
    }
    default:
      return state;
  }
}
